import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Endpoints from "../../utils/repository/Endpoints";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRightToBracket,
  faAt,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import Header from "../../utils/components/Header/Header";
import FormInput from "../../utils/components/FormInput/FormInput";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Es fehlt eine E-Mail!",
        text: "Bitte geben Sie eine E-Mail ein!",
        allowOutsideClick: false,
      });
      setIsSubmitting(false);
      return;
    }

    const payload = JSON.stringify({ email });

    try {
      const response = await fetch(Endpoints.api + Endpoints.forgotPassword, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      });

      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Erfolg",
          text: "Link zum Zurücksetzen wird an Ihre E-Mail gesendet. Bitte prüfen Sie Ihren Posteingang!",
          allowOutsideClick: false,
        }).then(() => {
          navigate("/");
        });

        setIsSubmitting(true);
      } else {
        throw new Error(
          data.message || "Die E-Mail kann nicht gesendet werden!"
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Fehler",
        text: error.message,
        allowOutsideClick: false,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <div
        id={"event"}
        style={{
          marginTop: 10,
          padding: 10,
          overflow: "hidden",
          height: "auto",
        }}
      >
        <div
          className="container"
          style={{ maxWidth: "750px", marginTop: "20px" }}
        >
          <h2>Passwort vergessen</h2>
          <p>
            Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen:
          </p>
          <form onSubmit={handleSubmit}>
            <FormInput
              type="email"
              id="user_email"
              placeholder="name@example.com"
              label="Email address"
              hint=""
              icon={faAt}
              value={email}
              setValue={setEmail}
            />

            <button
              type="submit"
              className="mt-2"
              disabled={isSubmitting}
              style={{
                height: 50,
                width: "100%",
                transition: "0.3s",
                backgroundColor: "#332885",
                color: "white",
                border: "1px solid #332885",
                borderRadius: 5,
              }}
            >
              {isSubmitting ? "Sendet..." : "Senden "}
              <FontAwesomeIcon icon={faPaperPlane} />
            </button>
          </form>
          <div className="mt-3">
            <Link
              to="/login"
              style={{ textDecoration: "none", color: "#332885" }}
            >
              Zurück zum Login <FontAwesomeIcon icon={faRightToBracket} />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
